import { axiosInstance } from '../axios';

const API_URL = '/api/partorders';

class PartOrdersService {

  async list(params) {
    let queryParams = new URLSearchParams();
    for (const [key, value] of Object.entries(params)) {
      if (value === null || value === undefined){
        continue;
      }
      queryParams.append(key, value);
    }
    return axiosInstance.get(
        `${API_URL}/list`,
        {
          params: queryParams,
        },
    );
  }

  async get(partOrderId) {
    return axiosInstance.get(
        `${API_URL}/get/${partOrderId}`);
  }

  async save(partOrder) {
    return axiosInstance.post(
        `${API_URL}/save`,
        partOrder,
    );
  }

  async sendEmail(partOrderId) {
    let queryParams = new URLSearchParams();
    queryParams.append('partOrderId', partOrderId);

    return axiosInstance.post(
        `${API_URL}/send-email`,
        null,
        {
          params: queryParams,
   //       responseType: 'application/json',
        },
    );
  }

  async delete(partOrderIds) {
    let data = new FormData();
    partOrderIds.forEach(id => data.append('ids', id) );
    return axiosInstance.delete(
        `${API_URL}/delete`,
        { data:data },
    );
  }

  async getCommonSuppliersForPartIds(partIds){
    let queryParams = new URLSearchParams();
    partIds.forEach(id => queryParams.append('partIds', id) );
    return axiosInstance.get(
        `${API_URL}/common-suppliers-for-parts`,
        {
          params: queryParams,
        },
    );
  }
}
export default new PartOrdersService();
